var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"background":"orange","padding":"20px","border":"3px solid red"}},[_c('h1',[_vm._v("NEW COMPONENT WORKS!")])])
}]

export { render, staticRenderFns }